import { render, staticRenderFns } from "./userSys.vue?vue&type=template&id=835d6148&scoped=true&"
import script from "./userSys.vue?vue&type=script&lang=js&"
export * from "./userSys.vue?vue&type=script&lang=js&"
import style0 from "./userSys.vue?vue&type=style&index=0&id=835d6148&lang=scss&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "835d6148",
  null
  
)

export default component.exports